// import "htmx.org";
import { Application } from "@hotwired/stimulus";

import { socketService } from "./services/socket_service";

// Stimulus controllers
import { HomeController } from "./controllers/home.controller";
import { DropdownController } from "./controllers/dropdown.controller";
import { NavController } from "./controllers/nav.controller";
import { AccordionController } from "./controllers/accordion.controller";
import { ValidationCodeController } from "./controllers/validation_code.controller";
import { TelInputController } from "./controllers/tel-input.controller";
import { PasswordToggleController } from "./controllers/password-toggle.controller";
import { FormInputController } from "./controllers/form-input.controller";
import { LevelController } from "./controllers/level.controller";
import { ToggleController } from "./controllers/toggle.controller";
import { DropdownMenuController } from "./controllers/dropdown-menu.controller";
import { ManagedModalController } from "./controllers/managed-modal.controller";
import { EducationExperienceModalController } from "./controllers/education-experience-modal.controller";
import { CertificationModalController } from "./controllers/certification-modal.controller";
import { CropperController } from "./controllers/cropper.controller";
import { CertificationUploadImageController } from "./controllers/certification-upload-image.controller";
import { DynamicListController } from "./controllers/dynamic-list.controller";
import { TabsController } from "./controllers/tabs.controller";
import { CertificationListController } from "./controllers/certification-list.controller";
import { VacancySelectionController } from "./controllers/vacancy-selection.controller";
import { ApplicantSelectionController } from "./controllers/applicant-selection.controller";
import { FiltersController } from "./controllers/filters.controller";
import { RemoveElementController } from "./controllers/remove-element.controller";
import { ConversationSearchController } from "./controllers/conversation-search.controller";
import { ConversationChatController } from "./controllers/conversation-chat.controller";
import { StripePaymentController } from "./controllers/stripe-payment.controller";

window.Stimulus = Application.start();
socketService.connect();

Stimulus.register("home", HomeController);
Stimulus.register("dropdown", DropdownController);
Stimulus.register("dropdown-menu", DropdownMenuController);
Stimulus.register("nav", NavController);
Stimulus.register("accordion", AccordionController);
Stimulus.register("validation-code", ValidationCodeController);
Stimulus.register("tel-input", TelInputController);
Stimulus.register("password-toggle", PasswordToggleController);
Stimulus.register("form-input", FormInputController);
Stimulus.register("level", LevelController);
Stimulus.register("toggle", ToggleController);
Stimulus.register("managed-modal", ManagedModalController);
Stimulus.register(
  "education-experience-modal",
  EducationExperienceModalController,
);
Stimulus.register("certification-modal", CertificationModalController);
Stimulus.register("cropper", CropperController);
Stimulus.register("certification-upload", CertificationUploadImageController);
Stimulus.register("dynamic-list", DynamicListController);
Stimulus.register("tabs", TabsController);
Stimulus.register("certification-list", CertificationListController);
Stimulus.register("vacancy-selection", VacancySelectionController);
Stimulus.register("applicant-selection", ApplicantSelectionController);
Stimulus.register("filters", FiltersController);
Stimulus.register("remove", RemoveElementController);
Stimulus.register("conversation-search", ConversationSearchController);
Stimulus.register("conversation-chat", ConversationChatController);
Stimulus.register("stripe-payment", StripePaymentController);

if (window.jQuery) {
  $(function () {
    $(".logos-slick").slick({
      dots: true,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      speed: 2000, // duración de la animación (ms)
      autoplaySpeed: 1000, // tiempo entre auto-avances (ms)
      arrows: false,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 4 } },
        { breakpoint: 900, settings: { slidesToShow: 3 } },
        { breakpoint: 700, settings: { slidesToShow: 2 } },
        { breakpoint: 480, settings: { slidesToShow: 1 } },
      ],
    });
  });
}

let currentScroll = 0;

document.body.addEventListener("htmx:beforeRequest", () => {
  currentScroll = window.scrollY;
});

document.body.addEventListener("htmx:afterSettle", () => {
  requestAnimationFrame(() => {
    window.scrollTo(0, currentScroll);
  });
});

const getCSRFToken = function () {
  const name = "csrftoken";
  const cookies = document.cookie.split(";");

  for (let cookie of cookies) {
    cookie = cookie.trim();

    if (cookie.startsWith(name + "=")) {
      return decodeURIComponent(cookie.substring(name.length + 1));
    }
  }

  return null;
};

document.body.addEventListener("htmx:configRequest", (event) => {
  const token = getCSRFToken();

  if (token) {
    event.detail.headers["X-CSRFToken"] = token;
  }
});

document.addEventListener("submit", function (e) {
  if (!(e.target instanceof HTMLFormElement)) return;

  const buttons = e.target.querySelectorAll(
    'button[type="submit"], input[type="submit"]',
  );

  buttons.forEach((btn) => (btn.disabled = true));
});

document.addEventListener(
  "click",
  (e) => {
    const a = e.target.closest("a");
    if (!a) return;
    // cierra todos los paneles visibles
    document.querySelectorAll('[data-controller="dropdown"]').forEach((el) => {
      const btn = el.querySelector('[data-dropdown-target="button"]');
      const pan = el.querySelector('[data-dropdown-target="panel"]');
      btn?.setAttribute("aria-expanded", "false");
      pan?.classList.add("hidden");
      el.setAttribute("aria-expanded", "false");
    });
    document.querySelectorAll('[data-controller="submenu"]').forEach((el) => {
      const btn = el.querySelector('[data-submenu-target="button"]');
      const pan = el.querySelector('[data-submenu-target="panel"]');
      btn?.setAttribute("aria-expanded", "false");
      pan?.classList.add("hidden");
      el.setAttribute("aria-expanded", "false");
    });
    // cierra nav móvil si está abierto
    const navMenu = document.querySelector('[data-nav-target="menu"]');
    const navBtn = document.querySelector('[data-nav-target="button"]');
    if (navMenu && !navMenu.classList.contains("hidden")) {
      navMenu.classList.add("hidden");
      navBtn?.setAttribute("aria-expanded", "false");
    }
  },
  { capture: true },
);
